import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-best-ifp-protection-sliding-shutter-india',
  templateUrl: './best-ifp-protection-sliding-shutter-india.component.html',
  styleUrls: ['./best-ifp-protection-sliding-shutter-india.component.scss']
})
export class BestIfpProtectionSlidingShutterIndiaComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('Best IFP Protection Sliding Shutter Provider in India | VIRSA');
    this.metaService.updateTag({
      name: 'description',
      content: 'Looking for the best IFP protection sliding shutter in India? VIRSA offers heavy-duty metal shutters with key-lock security, smooth sliding rails, and customizable writing and notice boards.'
    });
    this.metaService.updateTag({
      name: 'keywords',
      content: 'Best IFP Protection Sliding Shutters in India, Best IFP Protection Sliding Shutter Provider in India, IFP Sliding Shutter, Interactive Flat Panel Protection, Smart Board Protection Shutter, IFP Protective Cover, Interactive Panel Shutter, IFP Writing Board, IFP Notice Board'
    });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
